import { useEffect } from "react";

// Canonical/site base used for absolute URLs (canonical, OG, Twitter).
// Update this single constant if the primary domain changes.
export const SITE_URL = "https://www.growingitsolutions.com";
export const SITE_NAME = "Growing IT Solutions";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;
const DEFAULT_DESC =
  "Growing IT Solutions is a best-in-class AI service provider delivering Generative AI, RAG/GraphRAG, AI chatbots, automation and data engineering for clients in India and worldwide.";

function setMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function usePageMeta({ title, description, path = "", image } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | ${SITE_NAME}`
      : `${SITE_NAME} — AI Engineering & GenAI Experts`;
    const desc = description || DEFAULT_DESC;
    const url = `${SITE_URL}${path}`;
    const img = image || DEFAULT_IMAGE;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setLink("canonical", url);

    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE_NAME);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
  }, [title, description, path, image]);
}
